/**
 * `/_/kiosk`: the visitor kiosk (F-78 phase 1B). Public, no session, no app shell. The device's token
 * arrives once in the fragment (`#t=...`) and is kept in `localStorage` by the page.
 */
export const KIOSK_PATH = '/_/kiosk'

export const isKioskPath = (path: string): boolean => path === KIOSK_PATH || path === `${KIOSK_PATH}/`
